import React, { useState } from "react";
import "./index.scss";
import Header from "../../components/appLayout/header";
import portraitImage from "../../assets/images/womanoil.png";
import Popup from "../../components/common/Popup";

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await fetch("https://api.almasecret.msit-demo.fr/contacts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setShowSuccess(true);
        setFormData({
          fullname: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setError(data.message || "Erreur lors de l'envoi du message");
      }
    } catch (error) {
      setError("Erreur de connexion. Veuillez réessayer.");
    } finally {
      setIsLoading(false);
    }
  };

  // Check if all fields are filled
  const isFormValid =
    formData.fullname.trim() !== "" &&
    formData.phone.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.subject.trim() !== "" &&
    formData.message.trim() !== "";

  return (
    <div className="contact-page">
      <div className="header-home">
        <Header />
      </div>

      <div className="contact-container">
        {/* Circular ALMA text at top center */}
        <div className="circular-text-wrapper">
          <svg width="150" height="150" viewBox="0 0 150 150">
            <defs>
              <path
                id="circlePath"
                d="M 75, 75 m -60, 0 a 60,60 0 1,1 120,0 a 60,60 0 1,1 -120,0 "
              />
            </defs>
            <text
              fill="black"
              fontFamily="IvyJournal"
              fontSize="14"
              fontWeight="bold">
              <textPath href="#circlePath">
                ALMA - ALMA - ALMA - ALMA - ALMA - ALMA - ALMA - ALMA - ALMA -
                ALMA -
              </textPath>
            </text>
          </svg>
        </div>

        {/* Left side - Image section */}
        <div className="image-section">
          <div className="woman-portrait">
            <img
              src={portraitImage}
              alt="Woman with Alma Secret product"
              className="portrait-image"
            />
          </div>
        </div>

        {/* Right side - Contact form */}
        <div className="form-section">
          <div className="form-container">
            <h1 className="form-title">CONTACTEZ-NOUS!</h1>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleInputChange}
                  placeholder="NOM COMPLET*"
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="EMAIL*"
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="TELEPHONE*"
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleInputChange}
                  placeholder="SUJET*"
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="MESSAGE*"
                  rows="4"
                  required></textarea>
              </div>

              {error && <div className="contact-error">{error}</div>}

              <button
                type="submit"
                className={`submit-button ${
                  !isFormValid || isLoading ? "disabled" : ""
                }`}
                disabled={!isFormValid || isLoading}>
                <span className="arrow-icon">→</span>
                {isLoading ? "ENVOI EN COURS..." : "ENVOYER"}
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Success Popup */}
      <Popup
        isOpen={showSuccess}
        onClose={() => setShowSuccess(false)}
        title="Message envoyé avec succès!"
        message="Nous avons bien reçu votre message et vous répondrons dans les plus brefs délais."
        type="success"
        buttonText="Fermer"
        onButtonClick={() => setShowSuccess(false)}
      />
    </div>
  );
};
